import type { ActivityTypeResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toActivityType } from './toActivityType';

// Builds a normalized `Data.ActivityType` domain from a list of DTOs.
// Mirrors the other domain transformers — iterate via the shared helper and
// mutate-add each mapped item for performance over bulk inserts.
function toActivityTypeDomain(args: { dtos: ActivityTypeResponse[] }) {
  const { dtos } = args;

  const activityTypeDomain: NormalizedDomain<Data.ActivityType> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const activityType = toActivityType(item);
      domainUtility.mutateAdd(activityTypeDomain, activityType);
    },
  });

  return { activityTypeDomain };
}

export { toActivityTypeDomain };
